import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import DriverViewLocation from 'src/components/drivers/DriverViewLocation'
import { clearMap } from 'src/state/actions/google_map'
import * as driverActions from '../../state/actions/drivers'

const mapStateToProps = (state: IStoreState, props: any) => {
  const operatorId = props.operatorId
  const currentOperator = state.drivers.items[operatorId]
  const operatorLocation = state.drivers.operatorLocation ? state.drivers.operatorLocation : undefined

  return {
    operatorId: props.operatorId,
    orgId: state.organizations.currentOrgId,
    currentOperator,
    zones: state.goinzones.items,
    operatorLocation
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    clearMap: () => dispatch(clearMap()),
    getLocation: (operatorId: string) => dispatch(driverActions.getOperatorLocation(operatorId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverViewLocation)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverViewLocation.ts